module.exports = __webpack_public_path__ + "img/66.36c7b9c8.jpg";